module.exports = __webpack_public_path__ + "static/media/Boman Qujan_2026_Logo.44423ec5.png";